import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { formatDate, isWeekend } from '../lib/dates';

const { FiTrash2 } = FiIcons;

function HoursTable({ entries, onDelete }) {
  const subtotals = entries.reduce((result, entry) => {
    const name = entry.people?.name || 'Unknown';
    result[name] ||= { ordinary: 0, weekend: 0 };
    const key = isWeekend(entry.work_date) ? 'weekend' : 'ordinary';
    result[name][key] += Number(entry.hours_worked);
    return result;
  }, {});

  const ordinaryTotal = Object.values(subtotals).reduce((sum, item) => sum + item.ordinary, 0);
  const weekendTotal = Object.values(subtotals).reduce((sum, item) => sum + item.weekend, 0);

  return (
    <>
      <div className="table-scroll">
        <table>
          <thead>
            <tr><th>Date</th><th>Person</th><th>Hours</th><th aria-label="Actions" /></tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={entry.id}>
                <td className="nowrap">{formatDate(entry.work_date)}</td>
                <td>{entry.people?.name || 'Unknown'}</td>
                <td>{Number(entry.hours_worked).toFixed(2)}</td>
                <td>
                  <button className="table-delete" onClick={() => onDelete(entry.id, 'hours')}>
                    <SafeIcon icon={FiTrash2} />
                  </button>
                </td>
              </tr>
            ))}
            {!entries.length && <tr><td colSpan="4" className="empty-cell">No hours logged.</td></tr>}
          </tbody>
        </table>
      </div>

      {!!entries.length && (
        <div className="subtotal-grid">
          {Object.entries(subtotals).map(([name, total]) => (
            <div className="subtotal-item" key={name}>
              <strong>{name}</strong>
              <span>Ordinary: {total.ordinary.toFixed(2)}</span>
              <span>Weekend: {total.weekend.toFixed(2)}</span>
            </div>
          ))}
          <div className="subtotal-item total">
            <strong>Month total</strong>
            <span>Ordinary: {ordinaryTotal.toFixed(2)}</span>
            <span>Weekend: {weekendTotal.toFixed(2)}</span>
          </div>
        </div>
      )}
    </>
  );
}

export default HoursTable;